module.exports = __webpack_public_path__ + "img/charity.36a83b85.png";